<script>
  import Button from "./Button.svelte";
  import Dropdown from "./Dropdown.svelte";
  import NamePrompt from "./NamePrompt.svelte";
  import Modal from "./Modal.svelte";

  export let router;
  export let path;
  export let children;
  export let mode;
  export let removeChild;

  let childToBeRemoved = null

</script>


<main>
  {#each children.sort() as child}
    <div style='display: flex'>
      <a href={`/${mode}/${path}/${child}`} style='flex-grow: 1;'>{child}</a><br/>
      {#if removeChild}
        <Dropdown title='⋮' style='border: none' left="-64" width="100">
          <Button on:click={() => {
            childToBeRemoved = child;
            console.log(child)
          }} style='border: none; background-color: #fee; color: var(--foreground); width: 100%;'>🗑 Remove</Button>
        </Dropdown>
      {/if}
    </div>
  {/each}
  <NamePrompt name='+ New Child' style="width: 100%;" 
    on:submit={({detail}) => {router.redirect('/n/'+path+'/'+detail+'?rightPanel=0');}} />
</main>
{#if removeChild}
  <Modal bind:visible={childToBeRemoved}>
    <div style='display: flex; flex-direction: column; gap: 10px;'>
      <p>Are you sure you want to remove this node  with all its children and content? </p>

      <strong>/{path}/{childToBeRemoved}'</strong>

      <div style='display: flex; margin-top: 40px'>
        <Button on:click={() => {childToBeRemoved = null}}>Cancel</Button>
        <Button on:click={() => {removeChild(childToBeRemoved).then(() => null); childToBeRemoved = null}} 
          style="background-color: #f33; color: #fff; border: none">Yes, remove</Button>
      <dov>
    </div>
  </Modal>
{/if}
<style>
  a {
    line-height: 30px;
  }
  main {
    text-align: left;
  }
</style>